export class DataClientError extends Error {
  constructor(provider, code, message, originalError = null) {
    super(message);
    this.provider = provider; // 'graphql' | 'blazeo'
    this.code = code;
    this.originalError = originalError;
    this.name = "DataClientError";
  }
}
